// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/@rsbuild/core/compiled/css-loader/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.M2pETpfaTmsPITqD_cO4{height:100%;display:flex}.Y62L3lb2bQuylGw13mNG{width:100%;max-width:620px;padding:30px 80px 0;overflow-y:auto}.AVG3L0CNzQ0Bv7xd9QFv{position:relative}.HM53S69Z8MggEUBynEtq{border-left:1px solid var(--border-neutral-default);justify-content:center;padding:60px 64px 0;display:flex}.ENLgnhAdV0MariZSZQnK{background:var(--gray-a-15);border-radius:4px;margin-bottom:24px;padding:3.5px 8px;display:inline-block}.Sr3c2wFwwuszaTNByjVb{padding-top:32px}.SyTmVfxmo_8flZYMQ9tL{margin-bottom:6px;margin-left:8px}.SyTmVfxmo_8flZYMQ9tL:last-of-type{margin-bottom:0}.bNg78QcvcAYQCNoOzcC2{gap:8px;margin-top:30px;display:flex}.G3SNNCum2M8eziWVNZTm{height:100%}`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrap": `M2pETpfaTmsPITqD_cO4`,
	"keywordViewBox": `Y62L3lb2bQuylGw13mNG`,
	"keywordViewBox__isRelative": `AVG3L0CNzQ0Bv7xd9QFv`,
	"keywordViewBoxIsRelative": `AVG3L0CNzQ0Bv7xd9QFv`,
	"keywordPreviewBox": `HM53S69Z8MggEUBynEtq`,
	"label": `ENLgnhAdV0MariZSZQnK`,
	"section": `Sr3c2wFwwuszaTNByjVb`,
	"section__box": `SyTmVfxmo_8flZYMQ9tL`,
	"sectionBox": `SyTmVfxmo_8flZYMQ9tL`,
	"actionsWrap": `bNg78QcvcAYQCNoOzcC2`,
	"loading": `G3SNNCum2M8eziWVNZTm`
};
export default ___CSS_LOADER_EXPORT___;
